import { OverwriteConfirmDialog } from "@excalidraw/excalidraw/components/OverwriteConfirm/OverwriteConfirm";

import { appJotaiStore } from "../../app-jotai";
import { saveCurrentCloudDoc } from "../cloudActions";
import { getCurrentCloudDoc } from "../currentDoc";
import { cloudBrowserDialogAtom, saveToCloudDialogAtom } from "../dialogState";

/**
 * "Save to cloud" backup action for the overwrite-confirm dialog (shown when
 * opening a drawing would overwrite the current canvas). Lets the user save
 * the current drawing to the cloud before loading another.
 */
export const OverwriteConfirmSaveToCloud = () => (
  <OverwriteConfirmDialog.Action
    title="Save to cloud"
    actionLabel="Save to cloud"
    onClick={() => {
      if (getCurrentCloudDoc()) {
        void saveCurrentCloudDoc("tagged");
      } else {
        appJotaiStore.set(saveToCloudDialogAtom, {
          isOpen: true,
          mode: "save",
        });
      }
    }}
  >
    Save the current drawing to your cloud workspace before loading another.
  </OverwriteConfirmDialog.Action>
);

/**
 * "Open from cloud" action for the overwrite-confirm dialog — opens the cloud
 * browser to load a document instead of a local file.
 */
export const OverwriteConfirmOpenFromCloud = () => (
  <OverwriteConfirmDialog.Action
    title="From cloud"
    actionLabel="Browse cloud"
    onClick={() => {
      appJotaiStore.set(cloudBrowserDialogAtom, true);
    }}
  >
    Open one of your saved drawings from the cloud.
  </OverwriteConfirmDialog.Action>
);
